export const TECHNICIAN_STATUS_ACTIVE = 1
export const TECHNICIAN_STATUS_INACTIVE = 2

export function technicianStatusCode(label: string | null | undefined, currentStatus?: number): number {
  const normalized = label?.trim().toLowerCase()
  if (normalized === 'active') return TECHNICIAN_STATUS_ACTIVE
  if (normalized === 'inactive') return TECHNICIAN_STATUS_INACTIVE
  if (typeof currentStatus === 'number' && Number.isFinite(currentStatus)) return currentStatus
  return TECHNICIAN_STATUS_ACTIVE
}

export function technicianStatusLabel(status: number | string | null | undefined): 'Active' | 'Inactive' | null {
  if (status == null || status === '') return null
  const normalized = String(status).trim().toLowerCase()
  if (normalized === '1' || normalized === 'active') return 'Active'
  if (normalized === '2' || normalized === 'inactive') return 'Inactive'
  return null
}

export function technicianResolvedStatusLabel(
  status: number | string | null | undefined,
  statusLabel?: string | null,
): 'Active' | 'Inactive' {
  return technicianStatusLabel(status) ?? technicianStatusLabel(statusLabel) ?? 'Active'
}
